import { render, staticRenderFns } from "./GiveIntegral.vue?vue&type=template&id=5ec17622"
import script from "./GiveIntegral.vue?vue&type=script&lang=js"
export * from "./GiveIntegral.vue?vue&type=script&lang=js"
import style0 from "./GiveIntegral.vue?vue&type=style&index=0&id=5ec17622&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports